// @flow

import * as React from 'react';
import {useContext, useState} from 'react';
import {contextStubFunction} from 'docs/util';
import type {FileComponents} from './Files';

export type FileContextType = {|
  components: FileComponents,
  setComponents: (files: FileComponents) => void,
  contentRefs: {[string]: React.ElementRef<any>},
  setContentRef: (name: string, ref: React.ElementRef<any>) => void,
  activeFile: string,
  setActiveFile: (file: string) => void,
|};

export const FileContext = React.createContext<FileContextType>({
  components: {},
  setComponents: contextStubFunction('FileProvider'),
  contentRefs: {},
  setContentRef: contextStubFunction('FileProvider'),
  activeFile: '',
  setActiveFile: contextStubFunction('FileProvider'),
});

type FileProviderProps = {|
  children: React.Node,
|};

export const FileProvider = (props: FileProviderProps) => {
  // All of the File components based on the user's current settings
  const [components, setComponents] = useState({});
  // We need to keep track of refs to each File so we can
  // download or copy the current content the user sees
  const [contentRefs, setContentRefs] = useState({});
  const [activeFile, setActiveFile] = useState('');

  const setContentRef = (name: string, ref: React.ElementRef<any>) => {
    setContentRefs((prevRefs) => {
      return {...prevRefs, [name]: ref};
    });
  };

  const context = {
    components,
    setComponents,
    contentRefs,
    setContentRef,
    activeFile,
    setActiveFile,
  };

  return (
    <FileContext.Provider value={context}>
      {props.children}
    </FileContext.Provider>
  );
};

export const useFile = () => {
  return useContext(FileContext);
};
